"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialSpecEditViewModel = instanceOfMaterialSpecEditViewModel;
exports.MaterialSpecEditViewModelFromJSON = MaterialSpecEditViewModelFromJSON;
exports.MaterialSpecEditViewModelFromJSONTyped = MaterialSpecEditViewModelFromJSONTyped;
exports.MaterialSpecEditViewModelToJSON = MaterialSpecEditViewModelToJSON;
exports.MaterialSpecEditViewModelToJSONTyped = MaterialSpecEditViewModelToJSONTyped;
/**
 * Check if a given object implements the MaterialSpecEditViewModel interface.
 */
function instanceOfMaterialSpecEditViewModel(value) {
    return true;
}
function MaterialSpecEditViewModelFromJSON(json) {
    return MaterialSpecEditViewModelFromJSONTyped(json, false);
}
function MaterialSpecEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'msMaterialSpecNo': json['msMaterialSpecNo'] == null ? undefined : json['msMaterialSpecNo'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'msSpec': json['msSpec'] == null ? undefined : json['msSpec'],
        'pssSpecificationName': json['pssSpecificationName'] == null ? undefined : json['pssSpecificationName'],
        'msMaterialColorNo': json['msMaterialColorNo'] == null ? undefined : json['msMaterialColorNo'],
        'pcsColorStyleName': json['pcsColorStyleName'] == null ? undefined : json['pcsColorStyleName'],
        'msOrgId': json['msOrgId'] == null ? undefined : json['msOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'msMaterialId': json['msMaterialId'] == null ? undefined : json['msMaterialId'],
        'msCostPrice': json['msCostPrice'] == null ? undefined : json['msCostPrice'],
        'msCurrency': json['msCurrency'] == null ? undefined : json['msCurrency'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'msDeposit': json['msDeposit'] == null ? undefined : json['msDeposit'],
        'msSaveCount': json['msSaveCount'] == null ? undefined : json['msSaveCount'],
        'msLiveDateS': json['msLiveDateS'] == null ? undefined : json['msLiveDateS'],
        'msLiveDateE': json['msLiveDateE'] == null ? undefined : json['msLiveDateE'],
        'msSampLiveDateS': json['msSampLiveDateS'] == null ? undefined : json['msSampLiveDateS'],
        'msSampLiveDateE': json['msSampLiveDateE'] == null ? undefined : json['msSampLiveDateE'],
        'msRfid': json['msRfid'] == null ? undefined : json['msRfid'],
        'msActive': json['msActive'] == null ? undefined : json['msActive'],
        'msDisabledDate': json['msDisabledDate'] == null ? undefined : json['msDisabledDate'],
        'msOther': json['msOther'] == null ? undefined : json['msOther'],
        'msSalesAmount': json['msSalesAmount'] == null ? undefined : json['msSalesAmount'],
        'msSalesDate': json['msSalesDate'] == null ? undefined : json['msSalesDate'],
        'msBackstageKey': json['msBackstageKey'] == null ? undefined : json['msBackstageKey'],
        'msApidate': json['msApidate'] == null ? undefined : json['msApidate'],
        'msApitype': json['msApitype'] == null ? undefined : json['msApitype'],
    };
}
function MaterialSpecEditViewModelToJSON(json) {
    return MaterialSpecEditViewModelToJSONTyped(json, false);
}
function MaterialSpecEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'msMaterialSpecNo': value['msMaterialSpecNo'],
        'mdProduct': value['mdProduct'],
        'msSpec': value['msSpec'],
        'pssSpecificationName': value['pssSpecificationName'],
        'msMaterialColorNo': value['msMaterialColorNo'],
        'pcsColorStyleName': value['pcsColorStyleName'],
        'msOrgId': value['msOrgId'],
        'oName': value['oName'],
        'msMaterialId': value['msMaterialId'],
        'msCostPrice': value['msCostPrice'],
        'msCurrency': value['msCurrency'],
        'currency': value['currency'],
        'msDeposit': value['msDeposit'],
        'msSaveCount': value['msSaveCount'],
        'msLiveDateS': value['msLiveDateS'],
        'msLiveDateE': value['msLiveDateE'],
        'msSampLiveDateS': value['msSampLiveDateS'],
        'msSampLiveDateE': value['msSampLiveDateE'],
        'msRfid': value['msRfid'],
        'msActive': value['msActive'],
        'msDisabledDate': value['msDisabledDate'],
        'msOther': value['msOther'],
        'msSalesAmount': value['msSalesAmount'],
        'msSalesDate': value['msSalesDate'],
        'msBackstageKey': value['msBackstageKey'],
        'msApidate': value['msApidate'],
        'msApitype': value['msApitype'],
    };
}
